import { useCallback, useRef } from 'react'
import classNames from 'classnames'
import injectSheet from 'react-jss'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import HTMLParse from 'react-html-parser'
import DelayLink from '@/components/DelayLink'
import { useResize } from '@/components/Handlers'
import * as boundsActions from '@/actions/bounds'
import style from './style'

const FooterLanding = ({
  classes,
  className,
}) => {
  const $footer = useRef()

  /*------------------------------
  Redux Connect
  ------------------------------*/
  const { strings, legalsNav } = useSelector((state) => ({
    strings: state.options.strings || {},
    legalsNav: state.nav.legals_menu || [],
  }), shallowEqual)

  const dispatch = useDispatch()
  const setFooterBounds = useCallback((bounds) => dispatch(boundsActions.setBoundsElement('footer', bounds)), [dispatch])

  useResize(() => {
    if ($footer.current) setFooterBounds($footer.current.getBoundingClientRect())
  })

  /*------------------------------
  Render Left
  ------------------------------*/
  const renderLeft = () => {
    return (
      <div className={classes.footerLeft}>
        <p>
          ©
          {' '}
          {new Date().getFullYear()}
          {' '}
          {' '}
          {strings.company_name}
          {' '}
          {' '}
          P.IVA:
          {strings.piva}
        </p>
      </div>
    )
  }

  /*------------------------------
  Render Right
  ------------------------------*/
  const renderRight = () => {
    return (
      <div className={classes.footerRight}>
        <div>
          <p>{strings.footer_contacts_title}</p>
          {HTMLParse(strings.footer_address)}
        </div>
        <a className={classes.email} href={`mailto:${strings.email}`} target="_blank">{strings.email}</a>
        {legalsNav && (
          <DelayLink
            to={legalsNav[0].url}
            className={classes.legals}
          >
            {legalsNav[0].title}
          </DelayLink>
        )}
      </div>
    )
  }

  /*------------------------------
  Render Bottom Mobile
  ------------------------------*/
  const renderBottomMobile = useCallback(() => {
    return (
      <div className={classes.footerBottomMobile}>
        <p>
          ©
          {' '}
          {new Date().getFullYear()}
          {' '}
          {' '}
          {strings.company_name}
          {' '}
          {' '}
          P.IVA:
          {strings.piva}
        </p>
      </div>
    )
  }, [strings])

  return (
    <footer
      ref={$footer}
      className={classNames({
        Footer__root: true,
        [classes.root]: true,
        [className]: className,
      })}
    >
      <div className={classes.container}>
        <div className={classes.wrapper}>
          <div className={classes.footerBottom}>
            {renderLeft()}
            {renderRight()}
          </div>
          {renderBottomMobile()}
        </div>
      </div>
    </footer>
  )
}

export default injectSheet(style)(FooterLanding)
